import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
function RadioCheckedIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g
        id="Group_13871"
        data-name="Group 13871"
        transform="translate(-783 -219)"
      >
        <rect
          id="Rectangle_17708"
          data-name="Rectangle 17708"
          width="24"
          height="24"
          transform="translate(783 219)"
          fill="none"
        />
        <g
          id="Group_13870"
          data-name="Group 13870"
          transform="translate(-8 -1)"
        >
          <path
            id="Path_27336"
            data-name="Path 27336"
            d="M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z"
            transform="translate(793 222)"
            fill="#455DEE"
          />
          <path
            id="Path_27335"
            data-name="Path 27335"
            d="M18641,2053.269l2.271,2.27,4.539-4.539"
            transform="translate(-17841.5 -1821.5)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
export default RadioCheckedIcon;
